import { queries } from './queries';

/**
 * requests
 *
 * @type {{queries: {GetUserRoles: function({}=): Promise<{}>}}}
 */
export const requests = {
  queries,
};
